import { render, staticRenderFns } from "./taskProcess.vue?vue&type=template&id=22426219&scoped=true&"
import script from "./taskProcess.vue?vue&type=script&lang=js&"
export * from "./taskProcess.vue?vue&type=script&lang=js&"
import style0 from "./taskProcess.vue?vue&type=style&index=0&id=22426219&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22426219",
  null
  
)

export default component.exports